const TableHeader = ({ title, description, filters = [], actions = [] }) => {
  return (
    <div className="space-y-4">
      {/* Header Title Section */}
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            {title}
          </h3>
          {description && (
            <p className="mt-2 text-sm text-gray-700">{description}</p>
          )}
        </div>
      </div>

      {/* Filters and Actions Grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {/* Render Filters */}
        {filters.map((filter, index) => (
          <select
            key={`filter-${index}`}
            value={filter.value}
            onChange={(e) => filter.onChange(e.target.value)}
            className="block w-full rounded-md border-gray-300 py-1.5 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
          >
            {filter.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ))}

        {/* Render Actions */}
        {actions.map((action, index) => (
          <button
            key={`action-${index}`}
            onClick={action.onClick}
            className="inline-flex items-center justify-center px-4 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {action.icon && <action.icon className="mr-2 -ml-1 h-5 w-5" />}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TableHeader;
